import { Api } from '@/src/store'

export const VirtualCardApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /card/:cardAccountId/activate': {
      invalidatesTags: ['GET /card/:cardAccountId/virtual'],
    },
    'PUT /card/:cardAccountId/payments/methods': {
      invalidatesTags: [
        'GET /card/:cardAccountId/payments/methods',
        'GET /card/:cardAccountId/virtual',
      ],
    },
    'POST /card/:cardAccountId/freeze': {
      invalidatesTags: ['GET /card/:cardAccountId/virtual'],
    },
    'POST /card/:cardAccountId/unfreeze': {
      invalidatesTags: ['GET /card/:cardAccountId/virtual'],
    },
  },
})
